<template>
    <div class="automation-wizard-overview-scenario">
        <div v-if="triggerItem" class="automation-wizard-overview-scenario__trigger">
            <CompassColoredIcon
                icon="flash"
                color="teal"
                size="large"
                class="automation-wizard-overview-scenario__trigger-icon"
            />
            <p
                class="automation-wizard-overview-scenario__trigger-label typographies-paragraph-medium-bold"
            >
                {{ triggerItem.label }}
            </p>
        </div>
        <div
            v-if="triggerItem && actionItems.length > 0"
            class="automation-wizard-overview-scenario__separator"
        >
            <CompassIcon
                icon="arrow-down"
                class="automation-wizard-overview-scenario__separator-icon"
            />
        </div>
        <div v-if="actionItems.length > 0" class="automation-wizard-overview-scenario__actions">
            <div
                v-for="(action, index) in actionItems"
                :key="index"
                class="automation-wizard-overview-scenario__action"
            >
                <CompassColoredIcon
                    icon="target"
                    color="coral"
                    size="large"
                    class="automation-wizard-overview-scenario__action-icon"
                />
                <p
                    class="automation-wizard-overview-scenario__action-label typographies-paragraph-medium-bold"
                >
                    {{ action.label }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        scenario: {
            type: Array,
            required: true,
        },
    },
    computed: {
        triggerItem() {
            return this.scenario.find((item) => item.type === 'trigger') || null;
        },
        actionItems() {
            return this.scenario.filter((item) => item.type === 'action');
        },
    },
};
</script>

<style lang="scss" scoped>
.automation-wizard-overview-scenario {
    border: 1px solid var(--colors-common-border-lighter);
    border-radius: var(--spacing-1);
    padding: var(--spacing-4);

    &__trigger {
        display: flex;
        align-items: center;
        gap: var(--spacing-1);
        &-label {
            margin: 0;
            color: var(--colors-common-text-subtle-default);
        }
    }

    &__separator {
        height: 40px;
        width: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        &::before {
            content: '';
            position: absolute;
            top: 0;
            bottom: 0;
            left: 50%;
            width: 1px;
            background: var(--colors-common-border-lighter);
            z-index: 1;
        }
        &-icon {
            color: var(--colors-common-border-focus);
            background: var(--colors-common-background-default);
            position: relative;
            z-index: 2;
            margin: var(--spacing-1);
            border-radius: 50%;
        }
    }

    &__actions {
        display: flex;
        flex-direction: column;
        gap: var(--spacing-1);
    }
    &__action {
        display: flex;
        align-items: center;
        gap: var(--spacing-1);
        &-label {
            margin: 0;
            color: var(--colors-common-text-subtle-default);
        }
    }
}
</style>
